import produce from 'immer';
import * as types from './types';

const INITIAL_STATE = {
  error: null,
  loading: null,
  usersData: {
    data: [],
    totalCount: 0,
  },
  usersOrderBy: null,
  usersSearch: null,
};

export function users(state = INITIAL_STATE, action) {
  return produce(state, draft => {
    switch (action.type) {
      /**
       * ---------------------------------------------------
       *  GET USUÁRIOS DO SISTEMA
       * ---------------------------------------------------
       */

      case types.GET_USERS_REQUEST: {
        draft.usersOrderBy = action?.payload?.usersOrderBy;
        draft.usersSearch = action?.payload?.usersSearch;
        draft.loading = true;
        break;
      }
      case types.GET_USERS_SUCCESS: {
        draft.usersData = action?.payload?.usersData;
        draft.usersOrderBy = action?.payload?.usersOrderBy;
        draft.usersSearch = action?.payload?.usersSearch;
        draft.loading = false;
        draft.error = false;
        break;
      }
      case types.GET_USERS_FAILURE: {
        draft.loading = false;
        draft.error = true;
        break;
      }

      default:
        return state;
    }
  });
}
